import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import system from '../../system';
import '../../css-tokens';
import styles from './index.module.css';

/**
 * Note!
 *
 * This component is extended by Heading, Paragraph & Caption
 * Changes will also affect those components
 */
export const SYSTEM_PROPS = ['colorProps', 'flexProps', 'marginProps', 'textProps', 'floatProps', 'displayProps'];
const Text = /*#__PURE__*/function () {
  const Text = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      size,
      as,
      ...props
    } = _ref;
    const classnames = {
      [styles.root]: true,
      [styles.heading1]: size === 'Heading1',
      [styles.heading2]: size === 'Heading2',
      [styles.heading3]: size === 'Heading3',
      [styles.heading4]: size === 'Heading4',
      [styles.heading5]: size === 'Heading5',
      [styles.heading6]: size === 'Heading6',
      // If no size given, we take Heading6 as default
      [styles.paragraph]: size === 'Paragraph',
      [styles.caption1]: size === 'Caption1',
      [styles.caption2]: size === 'Caption2'
    };
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    return /*#__PURE__*/React.createElement(Base, _extends({
      as: as,
      className: cx(classnames, className),
      ref: ref,
      style: style
    }, rest));
  });
  Text.displayName = 'Text';
  Text.identifier = Text.displayName;
  Text.clonableProps = SYSTEM_PROPS;
  Text.defaultProps = {
    as: 'span',
    size: 'Heading6'
  };
  return Text;
}();
export default Text;